import { CommonModule } from '@angular/common';
import { ErrorHandler, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ApmErrorHandler, ApmModule } from '@elastic/apm-rum-angular';
import { TrackingService } from './tracking.service';

@NgModule({
  providers: [
    TrackingService,
    {
      provide: ErrorHandler,
      useClass: ApmErrorHandler,
    },
  ],
  declarations: [],
  imports: [CommonModule, RouterModule, ApmModule],
})
export class TrackingModule {
  constructor(trackingService: TrackingService) {
    trackingService.init();
  }
}
